import { openBlock as e, createElementBlock as o, createElementVNode as t } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, r = /* @__PURE__ */ t("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "m19 9-7 6-7-6"
}, null, -1), s = [
  r
];
function c(l, d) {
  return e(), o("svg", n, [...s]);
}
const a = { render: c };
export {
  a as default,
  c as render
};
